<template>
  <div class="page">
    <div class="page-wrap">
      <expert-item class="item" v-for="item in expert_list" :key="item.id" :data="item" ></expert-item>
    </div>
  </div>
</template>

<script>
  import ExpertItem from "@/views/pages/expert/components/ExpertItem";
  export default {
    name: "expert",
    data() {
      return {
        expert_list:[]
      };
    },
    components: {
      ExpertItem,
    },
    created() {
      this.getExpertList();
    },
    mounted() {},
    methods: {
      async getExpertList() {
        try {
          const config = {
            params: {},
            data: {
              is_zhongtu: 1,
              keywords: "",
              title: "",
              skill: "",
              province: "",
            },
          };
          const res = await this.$api.fetchExpertList(config);
          console.log("list", res);
          this.expert_list = res.data.expert_list
          return res;
        } catch (err) {
          return Promise.reject(err)
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .page {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    .page-wrap {
      display: flex;
      flex-wrap: wrap;

      .item {
        margin-right: 65px;
        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
</style>
